import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const ButtonBox = styled(Box)`
  display: flex;
  padding-right: 24px;
  justify-content: right;
`;

export const TutorsLoaderGrid = styled(Grid)`
  display: flex;
  justify-content: center;
`;

export const SpinnerWrapper = styled(Box)`
  margin: ${(props) => `${props?.theme?.palette?.spacing[0] * 1}px`};
  position: relative;
`;
